type AnalyticsPayload = Record<string, unknown> | undefined;

// gtag/dataLayer page fields on credential-bearing surfaces (invite links carry
// ?code= secrets): override page_location/page_referrer so queries and hashes
// never leave in an event payload.
export function sanitizedPageFields(): { page_location?: string; page_referrer?: string } {
  if (typeof window === 'undefined') return {};
  const fields: { page_location?: string; page_referrer?: string } = {
    page_location: window.location.origin + window.location.pathname,
  };
  try {
    if (document.referrer) {
      const ref = new URL(document.referrer);
      fields.page_referrer = ref.origin + ref.pathname;
    }
  } catch {
    // unparsable referrer — omit rather than leak
  }
  return fields;
}

// Lightweight analytics helper that plays nicely with optional tools like gtag/dataLayer
export function trackEvent(eventName: string, payload?: AnalyticsPayload): void {
  try {
    if (typeof window === 'undefined') return;

    const w = window as any;
    const data = payload || {};

    // Google Analytics / gtag support
    if (typeof w.gtag === 'function') {
      w.gtag('event', eventName, data);
    }

    // Generic dataLayer support (e.g. GTM)
    if (Array.isArray(w.dataLayer)) {
      w.dataLayer.push({ event: eventName, ...data });
    }

    // Dev-mode console logging for visibility
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.log('[analytics]', eventName, data);
    }
  } catch (err) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('[analytics] error sending event', eventName, err);
    }
  }
}
